import React, {useContext, useState} from 'react';
import Loading from '../../../components/Loading';
import TeacherDetailsBody from './teacher-details-body/teacher-details-body';
import { RemoveTeacher } from '../../../components/exl/TeacherHelperFunctions';
import useTeacherDetails from './use-teacher-details';
import TeacherDetailsHeader from './teacher-details-header/teacher-details-header';
import { DataContext as SharedDataContext } from '../../../stores/crm-store';
import EditTeacher from '../../../components/exl/EditTeacher';
import CustomModal from '../../../components/tables/shared/CustomModal';
import ExlToasts from '../../../components/crm/shared/ExlToasts';
import ExlFileUploadModal from '../../../components/exl/shared/ExlFileUploadModal';
import { HandleAddExlFile, HandleRemoveExlFile } from '../../../components/crm/requests/FileRequests';
import { useTranslation } from 'react-i18next';
import { DELETE, TEACHER_DETAILS_DELETE_TEACHER_CV_WARN, TEACHER_DETAILS_DELETE_TEACHER_WARN, TEACHER_DETAILS_UPLOAD_CV, TEACHER_DETAILS_UPLOAD_CV_LABEL } from '../../../i18n/keyConstants';

export default function TeacherDetails({ id: teacherId }) {
  const [editTeacherModalOpen, setEditTeacherModalOpen] = useState(false);
  const [uploadCVModalOpen, setUploadCVModalOpen] = useState(false);
  const [deleteTeacherModalOpen, setDeleteTeacherModalOpen] = useState(false);
  const [deleteTeacherCVModalOpen, setDeleteTeacherCVModalOpen] = useState(false);
  const { t } = useTranslation(['teacherDetails', 'teacherDetailsHeader','shared']);

  const [isRemoving, setIsRemoving] = useState();

  const handleRemoveTeacher = async (teacherId, sharedDispatch) => {
      setIsRemoving(true);
      await RemoveTeacher(teacherId, sharedDispatch, t);
      setIsRemoving(false);
  }

  const handleRemoveTeacherCV = async (teacherId) => {
      setIsRemoving(true);
      await HandleRemoveExlFile(teacherId)
      setIsRemoving(false);
      setDeleteTeacherCVModalOpen(false);
      refreshTeacherData();
    }

  async function handleAddCV(file, teacherId) {
      await HandleAddExlFile(file, teacherId)
      setUploadCVModalOpen(false);
      refreshTeacherData();
  }
  
  const { dispatch: sharedDispatch } = useContext(SharedDataContext);

  const {
    teacher,
    loading,
    teacherUser,
    teacherCourses,
    refreshTeacherData,
  } = useTeacherDetails(teacherId);

  return ( 
    <>
      {loading && (
        <Loading />
      )}

      {!loading && teacher && teacherUser &&(
        <div style={{ margin: "0px auto", maxWidth: '1200px', padding: "24px" }}>
          <TeacherDetailsHeader 
            teacher={teacher}
            teacherUser={teacherUser}
            refreshTeacherData={refreshTeacherData}
            setEditTeacherModalOpen={setEditTeacherModalOpen}
            setUploadCVModalOpen={setUploadCVModalOpen}
            setDeleteTeacherModalOpen={setDeleteTeacherModalOpen}
            setDeleteTeacherCVModalOpen={setDeleteTeacherCVModalOpen}

          />
            <TeacherDetailsBody
                teacher={teacher} teacherUser={teacherUser} teacherCourses={teacherCourses}/>
        </div>
      )}



      {!loading && teacher && teacherUser && (
        <>
          {editTeacherModalOpen && (
            <EditTeacher
              open={editTeacherModalOpen}
              onClose={() => setEditTeacherModalOpen(false)}
              updateTeacher={teacher}
              submitHandler={refreshTeacherData}
            />
          )}
          {uploadCVModalOpen && (
            <ExlFileUploadModal
              open={uploadCVModalOpen}
              onClose={() => setUploadCVModalOpen(false)}
              handleAdd={handleAddCV}
              updateTeacher={teacher}
              submitHandler={refreshTeacherData}
              description={t(TEACHER_DETAILS_UPLOAD_CV_LABEL)}
              teacher={teacher}
            />
          )}

          <CustomModal
            show={deleteTeacherModalOpen}
            onHide={() => setDeleteTeacherModalOpen(false)}
            modalText={t(TEACHER_DETAILS_DELETE_TEACHER_WARN) }
            buttonText={t(DELETE, {ns: 'shared'})}
            handleModal={() => {handleRemoveTeacher(teacherId, sharedDispatch)}}
            modalVariant='danger'
            isSaving={isRemoving }
          />
          <CustomModal
            show={deleteTeacherCVModalOpen}
            onHide={() => setDeleteTeacherCVModalOpen(false)}
            modalText={t(TEACHER_DETAILS_DELETE_TEACHER_CV_WARN)}
            buttonText={t(DELETE, {ns: 'shared'})}
            handleModal={() => { handleRemoveTeacherCV(teacherId) }}
            modalVariant='danger'
            isSaving={isRemoving}
          />

          <ExlToasts />
        </>
      )}
    </>
  );
}
